import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

const faqs = [
  {
    q: 'Do you offer free pickup and delivery?',
    a: 'Yes! We provide free pickup and delivery service throughout Mountain Home, AR. Simply call us or fill out our contact form to schedule a convenient time. We offer both one-time and recurring pickup schedules.',
  },
  {
    q: 'What areas do you serve?',
    a: 'We serve Mountain Home, Arkansas and the surrounding Twin Lakes area. Our free pickup and delivery covers most addresses in the Mountain Home community. Call us at (870) 425-4295 to confirm service in your area.',
  },
  {
    q: 'Do you offer wash and fold service?',
    a: 'Absolutely! Our Wash, Dry & Fold service includes sorting by color and fabric type, pre-treating stains, washing with quality detergents, drying, and carefully folding your clothes. You can drop off at our location or schedule a free pickup.',
  },
  {
    q: 'Do you service commercial accounts?',
    a: 'Yes, we provide commercial laundry service for businesses including Airbnb/VRBO hosts, medical clinics, spas, barber shops, and more. We offer customized plans, flexible billing, and no contracts. Contact us for a quote.',
  },
  {
    q: 'Can you wash comforters and bulky items?',
    a: 'Yes! We have extra-large washers and dryers specifically designed for comforters, blankets, sleeping bags, and other bulky items. You can use our self-service machines or drop off for our wash & fold service.',
  },
  {
    q: 'Do you offer same-day or next-day turnaround?',
    a: 'We offer fast turnaround with same-day and next-day service available for most orders. Turnaround times may vary based on load size and current demand. Contact us for specific timing on your order.',
  },
  {
    q: 'Do you provide recurring service?',
    a: 'Yes! We offer scheduled recurring service — weekly, bi-weekly, or on a custom schedule that works for you. This is perfect for busy households and businesses that need consistent, reliable laundry service.',
  },
  {
    q: 'Do you handle Airbnb, VRBO, or medical laundry?',
    a: 'Absolutely. We work with vacation rental hosts, medical clinics, surgery centers, physical therapy offices, spas, and more. Our commercial service includes reliable turnaround and customized plans to help your business run smoothly. Contact us for details.',
  },
  {
    q: 'What are your hours of operation?',
    a: 'We are open Monday through Friday from 8:00 AM to 5:00 PM, and Saturday from 8:00 AM to 4:00 PM. We are closed on Sundays. Feel free to call us at (870) 425-4295 during business hours.',
  },
  {
    q: 'Is there a contract for commercial service?',
    a: "No contract is required! We won't tie you down. You can pause, stop, and resume service at any time with no penalty. We also offer flexible billing options to fit your business needs.",
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-24 md:py-32 bg-white" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-12 reveal">
          <span className="inline-block text-poly-green font-semibold text-sm tracking-wider uppercase mb-3">
            FAQ
          </span>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl text-poly-blue-dark tracking-tight mb-4">
            Frequently Asked{' '}
            <span className="text-poly-blue">Questions</span>
          </h2>
          <p className="text-poly-muted text-base sm:text-lg">
            Quick answers to common questions about our laundry services.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="reveal reveal-delay-1">
          <Accordion type="single" collapsible className="space-y-2" data-testid="faq-accordion">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border border-slate-100 rounded-xl px-6 data-[state=open]:bg-poly-bg data-[state=open]:border-poly-blue-light/30 transition-all"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-semibold text-poly-blue-dark hover:no-underline py-5 text-base">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-poly-muted text-sm leading-relaxed pb-5">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
